/* import __COLOCATED_TEMPLATE__ from './checking-dropdown.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import assert from '@banking/ui/utils/assert';
let CheckingDropdown = (_class = class CheckingDropdown extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "applicationRouter", _descriptor, this);
    _initializerDefineProperty(this, "dataApi", _descriptor2, this);
    _initializerDefineProperty(this, "features", _descriptor3, this);
    _initializerDefineProperty(this, "router", _descriptor4, this);
  }
  transitionToOldCardSettings(unitToken) {
    this.router.transitionTo('money.square_card.manage', {
      queryParams: {
        unitToken
      }
    });
  }
  transitionToNewCardSettings(unitToken, cardToken) {
    this.applicationRouter.transitionTo('banking.card-settings', unitToken, cardToken);
  }
  trackCheckingSettingsClick() {
    this.dataApi.track('Click Checking Overview', {
      action: 'Click',
      applet: 'Banking',
      feature: 'Square Checking Home',
      page: 'Checking Overview',
      target: 'Navigate To Checking Settings'
    });
  }
  onTransferSettingsClick(unitToken) {
    this.dataApi.track('Click Checking Overview', {
      action: 'Click',
      applet: 'Banking',
      page: 'Checking Overview',
      target: 'Navigate To Transfer Settings'
    });
    this.applicationRouter.transitionTo('money.settings', {
      queryParams: {
        currentUnitToken: unitToken
      }
    });
  }
  onDisputesClick(unitToken) {
    this.dataApi.track('Click Checking Overview', {
      action: 'Click',
      applet: 'Banking',
      page: 'Checking Overview',
      target: 'Navigate To Square Card Disputes'
    });
    this.applicationRouter.transitionTo('square-card.disputes', {
      queryParams: {
        unitToken
      }
    });
  }
  onCheckingSettingsClick(unitToken, primaryCardToken) {
    assert(typeof unitToken === 'string');
    this.trackCheckingSettingsClick();
    if (typeof primaryCardToken === 'string') {
      this.transitionToNewCardSettings(unitToken, primaryCardToken);
    } else {
      this.transitionToOldCardSettings(unitToken);
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "applicationRouter", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "dataApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "onTransferSettingsClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onTransferSettingsClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onDisputesClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onDisputesClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onCheckingSettingsClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onCheckingSettingsClick"), _class.prototype), _class);
export { CheckingDropdown as default };